import { useGetClientProfile } from 'admin/features/clients/viewClientDetails/accountInfoClientTab';
import { EditIcon } from 'assets/icons';
import { CustomButton } from 'Components/Auth/CustomButton';
import UserInfo from 'Components/Profile/UserInfo';
import Spinner from 'Components/Spinner';
import { capitalize } from 'lodash';
import { useNavigate } from 'react-router-dom';

export interface IViewPersonalDetailsProps {}

export default function ViewPersonalDetails(props: IViewPersonalDetailsProps) {
  const { client } = useGetClientProfile();
  let navigate = useNavigate();

  function sortDependants(a: any, b: any) {
    var dateA = a.id;
    var dateB = b.id;
    return dateA > dateB ? 1 : -1;
  }
  let tempData;

  if (!client) return <Spinner />;
  if (client) {
    tempData =
      client.dependents?.map((dep: any) => ({
        id: dep?.id,
        relationship: capitalize(dep?.relationship).replace('_', ' '),
        firstname: dep?.firstname,
        lastname: dep?.lastname,
        ssn: dep?.ssn,
        birth_date: dep?.birth_date,
      })) || [];
    tempData.sort(sortDependants);
  }

  return (
    <div className="p-4">
      <div className=" mb-3">
        <p className="text-green text-base font-bold ">Personal Information</p>
      </div>
      <div className="grid gap-4">
        <UserInfo
          label="Social Security Number (SSN)"
          userInfo={client.ssn || 'N/A'}
        />
        <UserInfo
          label="Date of Birth"
          userInfo={
            (client.birth_date &&
              new Date(client.birth_date).toLocaleDateString('en-US')) ||
            'N/A'
          }
        />
        <UserInfo label="Occupation" userInfo={client.occupation || 'N/A'} />
        <hr />
      </div>
      <div className="mt-6 mb-3">
        <p className="text-green text-base font-bold ">Spouse Information </p>
      </div>
      <div className="grid gap-4">
        <UserInfo
          label="Tax Filing Status"
          userInfo={client.tax_filing_status || 'N/A'}
        />
        {client.spouse && (
          <>
            <UserInfo
              label="Spouse's Name"
              userInfo={client.spouse.firstname || 'N/A'}
            />
            <UserInfo
              label="Social Security Number (SSN)"
              userInfo={client.spouse.ssn || 'N/A'}
            />
            <UserInfo
              label="Spouse's Date of Birth"
              userInfo={
                (client.spouse.birth_date &&
                  new Date(client.spouse.birth_date).toLocaleDateString(
                    'en-US',
                  )) ||
                'N/A'
              }
            />
            <UserInfo
              label="Spouse's Email"
              userInfo={client.spouse.email || 'N/A'}
            />
            <UserInfo
              label="Spouse's Phone Number"
              userInfo={client.spouse.phone_number || 'N/A'}
            />
            <UserInfo
              label="Spouse's Occupation"
              userInfo={client.spouse.occupation || 'N/A'}
            />
          </>
        )}
        <hr />
      </div>
      <div className="mt-6 mb-3">
        <p className="text-green text-base font-bold ">Dependent Information</p>
      </div>
      <UserInfo
        className="my-4"
        label={'Have any dependent children or other dependents?'}
        userInfo={
          Object.keys(client?.dependents || []).length > 0 ? 'Yes' : 'No'
        }
      />
      {client.dependents &&
        tempData?.map((dep: any, index: number) => (
          <div
            className="border border-gray-100 pl-4 w-1/2 rounded-lg mb-9   md-max:w-full"
            key={dep.id}
          >
            <div className="mt-6 mb-3">
              <p className="text-green text-base font-bold ">
                Dependent {index + 1}
              </p>
            </div>

            <UserInfo
              className="my-4"
              label="Relationship"
              userInfo={dep.relationship || 'N/A'}
            />
            <UserInfo
              className="my-4"
              label="Name"
              userInfo={
                dep.firstname && dep.lastname
                  ? dep.firstname.concat(' ', dep.lastname)
                  : dep.firstname
                  ? dep.firstname
                  : 'N/A'
              }
            />
            <UserInfo
              className="my-4"
              label="Social Security Number (SSN)"
              userInfo={dep.ssn || 'N/A'}
            />
            <UserInfo
              className="my-4"
              label="Date of Birth"
              userInfo={
                (dep.birth_date &&
                  new Date(dep.birth_date).toLocaleDateString('en-US')) ||
                'N/A'
              }
            />
          </div>
        ))}
      <div className="w-1/4 flex flex-inline gap-4 mt-6   md-max:w-full">
        <CustomButton
          type="submit"
          text="Edit Personal Details"
          prefix={<EditIcon />}
          onClick={() => navigate(`edit`)}
          height="10"
        />
      </div>
    </div>
  );
}
